module.exports = {
    CHOICE_ALGO_A: 'ALGO_A'
};
